import { IExportPlugin, PluginType } from '@/version-types';
import { RenderEditLayer } from './view/render-edit-layer';

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 0,
    name: 'real-edit-layer',
    render() {
        return <RenderEditLayer />;
    },
};

export default exportPlugin;
